<div class="input-password">
	<input
		[type]="type"
		class="input-app"
		placeholder="{{ placeholder }}"
		[disabled]="disabled"
		(input)="onInput($event)"
		[value]="value"
    autocomplete="current-password"	/>
	<mat-icon
		class="icon-password"
		[ngClass]="{ 'cursor-pointer': !disabled }"
		(click)="changeMode()"
	>
		{{ type === 'password' ? 'visibility' : 'visibility_off' }}
	</mat-icon>
</div>
